import { styled, Box } from '@mui/material';
import { Link } from 'react-router-dom';

const LinkStyled = styled(Link)(() => ({
  textDecoration: 'none',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: '100%',
  width: '90%',
  position: 'relative',
}));

const Logo = () => {
  return (
    <LinkStyled to="/">
      <Box
        sx={{
          position: 'relative',
          width: '100%',
          height: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <img
          src="/images/logos/inversorhub-logo.png"
          alt="InversorHUB Logo"
          style={{
            maxWidth: '100%',
            maxHeight: '100%',
            objectFit: 'contain',
          }}
        />
      </Box>
    </LinkStyled>
  );
};

export default Logo;
